import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-courses-monitoring-view-part',
	standalone: true,
	templateUrl: './monitoring-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./monitoring-view.part.scss'],
})
export class ExperienceCoursesMonitoringViewPart {
}